import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const generateTimeOptions = (interval = 15) => {
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let min = 0; min < 60; min += interval) {
      const date = new Date();
      date.setHours(hour);
      date.setMinutes(min);
      const label = date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
      times.push({ label, value: label });
    }
  }
  return times;
};

const timeOptions = generateTimeOptions();

const parseTime = (timeString) => {
  if (typeof timeString !== 'string' || !timeString.includes(':')) {
    return [0, 0, 'AM'];
  }
  const [time, period] = timeString.trim().split(' ');
  const [hour, minute] = time.split(':').map(Number);
  return [hour, minute, period];
};

const getDateFromTime = (timeString) => {
  const [hour, minute, period] = parseTime(timeString);
  const date = new Date();
  date.setHours(
    period === 'PM' && hour !== 12
      ? hour + 12
      : hour === 12 && period === 'AM'
      ? 0
      : hour
  );
  date.setMinutes(minute);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

const TimePicker = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  minTime,
  error,
  touched,
  disabled,
}) => {
  const selectRef = useRef(null);

  const filterOptions = () => {
    if (!minTime) return timeOptions;

    const minDate = getDateFromTime(minTime);
    return timeOptions.filter(({ value }) => {
      const optionDate = getDateFromTime(value);
      return optionDate.getTime() > minDate.getTime();
    });
  };

  const filteredOptions = filterOptions();

  const handleMenuOpen = () => {
  setTimeout(() => {
    const nineAMIndex = filteredOptions.findIndex(
      (opt) => opt.value === "10:30 AM"
    );
    if (nineAMIndex > -1) {
      const el = document.querySelector(
        `[id^="react-select-"][id$="-option-${nineAMIndex}"]`
      );
      if (el) {
        el.scrollIntoView({ block: "nearest" });
      }
    }
  }, 0); 
};

  return (
    <div className="mb-3">
      {label && <label className="form-label">{label}</label>}
      <Select
        ref={selectRef}
        name={name}
        options={filteredOptions}
        value={filteredOptions.find((option) => option.value === value) || null}
        onChange={(option) => onChange(option ? option.value : '')}
        onBlur={onBlur}
        placeholder="Select time"
        classNamePrefix="select2-selection"
        isDisabled={disabled}
        menuPlacement="auto"
        onMenuOpen={handleMenuOpen} 
      />
      {error && touched && (
        <div className="invalid-feedback d-block">{error}</div>
      )}
    </div>
  );
};

TimePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.string.isRequired,
  minTime: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  disabled: PropTypes.bool,
};

TimePicker.defaultProps = {
  disabled: false,
};

export default TimePicker;
